import PropTypes from 'prop-types';

function PrivacyAndPolicy({data}) {
  // ✅ Always prefer Privacy Policy terms if present
  const terms =
    data?.PrivacyAndPolicy?.terms ||
    data?.TermsAndConditions?.PrivacyAndPolicy?.terms ||
    data?.terms ||
    [];

  return (
    <div className={'w-full flex flex-col justify-center items-center lg:px-20 p-4'}>
      <h1 className={'md:text-4xl text-3xl my-6 text-primary-900 font-semibold text-center font-instrument'}>
        Privacy Policy
      </h1>

      <div className={'w-full max-w-5xl bg-primary-50 rounded-2xl shadow-lg p-6 lg:p-10'}>
        <p className={'p-4 md:text-lg text-base font-medium text-[#2b3641] leading-relaxed'}>
          At <b className={'underline'}>Kalapi.store</b>, this Privacy Policy explains how we
          collect, use, share, and safeguard your information in accordance with the
          <b> Digital Personal Data Protection Act, 2023 (DPDP Act)</b> and other applicable
          Indian laws.
        </p>

        <ul className={'list-disc md:p-6 p-2'}>
          {terms.map(item => (
            <li key={item.id || item.term} className={'mb-6'}>
              <h2 className={'font-semibold md:text-xl text-base font-serif mb-1'}>
                {item.term}
              </h2>

              <div className={'md:text-[16px] text-base text-gray-700 text-[#2b3641] font-medium leading-relaxed'}>
                {item.description.split('\n').map((line, index) => (
                  <p key={index} className={'mb-2'}>
                    {line}
                  </p>
                ))}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

PrivacyAndPolicy.propTypes = {
  data: PropTypes.object.isRequired,
};

export default PrivacyAndPolicy;
